import { IconProps } from "@design-system/types";

export function ColoredLogoIcon(props: IconProps) {
  return (
    <svg
      {...props}
      width="304"
      height="49"
      viewBox="0 0 304 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M162.176 1.02185H152.56V48.6401H162.176V1.02185Z"
        fill="#0028ED"
      />
      <path
        d="M115.036 1.02185V48.6464H124.652V17.5022L147.657 43.1215V26.3583L124.652 1.02185H115.036Z"
        fill="#0028ED"
      />
      <path
        d="M71.8735 1.02185V48.6464H109.492V39.0234H81.4965V10.6448H109.492V1.02185H71.8735Z"
        fill="#0028ED"
      />
      <path
        d="M106.833 19.7964H86.3679V29.4131H106.833V19.7964Z"
        fill="#0028ED"
      />
      <path
        d="M242.177 10.5505L250.844 28.1685H233.603L242.177 10.5505ZM235.891 1.02185L220.392 36.7418L225.244 48.6401L229.7 37.6846H254.628L259.034 48.6401H269.323L248.657 1.02185H235.891Z"
        fill="#0028ED"
      />
      <path
        d="M259.612 1.02185V10.6448H274.565V48.6464H284.094V10.6448H294.094L304 1.02185H259.612Z"
        fill="#0028ED"
      />
      <path
        d="M185.866 1.02185L165.199 48.6464H175.294L179.675 37.6909H199.21L195.483 28.1685H183.578L192.246 10.5505L209.009 48.6464H219.292L198.914 1.78867L198.625 1.02185H185.866Z"
        fill="#0028ED"
      />
      <path
        d="M10.7355 20.4626C9.42811 19.2621 8.68015 17.5776 8.68015 15.7172C8.68015 12.1408 11.5903 9.23063 15.1667 9.23063H26.449L26.5873 9.13634L38.5924 0.556763H15.1604C6.80081 0.556763 0 7.35757 0 15.7172C0 19.4004 1.31994 22.8574 3.62039 25.5538L10.7355 20.4689V20.4626Z"
        fill="#0028ED"
      />
      <path
        d="M53.602 0.556763C49.8999 0.556763 46.2921 1.7007 43.2688 3.83145L35.2549 9.48204L7.91968 29.0297C8.00767 29.0799 8.09567 29.1302 8.18366 29.1805C10.3898 30.3245 12.7846 30.8901 15.1668 30.8901C18.234 30.8901 21.2825 29.9536 23.8972 28.112L62.9987 0.556763H53.5957H53.602Z"
        fill="#0028ED"
      />
      <path
        d="M55.8269 28.9983C57.1343 30.1988 57.8822 31.8833 57.8822 33.7438C57.8822 37.3202 54.9721 40.2303 51.3957 40.2303H40.1134L39.9751 40.3246L27.97 48.9042H51.3894C59.749 48.9042 66.5498 42.1034 66.5498 33.7438C66.5498 30.0605 65.2299 26.6035 62.9294 23.9071L55.8143 28.992L55.8269 28.9983Z"
        fill="#0028ED"
      />
      <path
        d="M12.9607 48.9105C16.6628 48.9105 20.2706 47.7665 23.2939 45.6295L31.3078 39.9789L58.6431 20.4313C58.5551 20.381 58.4671 20.3307 58.3791 20.2804C56.1729 19.1365 53.7781 18.5708 51.396 18.5708C48.3287 18.5708 45.2803 19.5073 42.6655 21.3489L3.55774 48.9105H12.9607Z"
        fill="#0028ED"
      />
    </svg>
  );
}
